import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

import {
  ExecutionListResponse,
  MenuManagementExecutionCreateParams,
  MenuManagementExecutionListParams,
  ShowExecutionResponse,
} from './hooks';

interface Interface {
  list: (
    params: MenuManagementExecutionListParams
  ) => Promise<ExecutionListResponse[]>;
  create: (params: MenuManagementExecutionCreateParams) => Promise<void>;
  show: (id: string) => Promise<ShowExecutionResponse>;
  delete: (id: string) => Promise<void>;
}
export class MenuManagementExecutionService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(
    params: MenuManagementExecutionListParams
  ): Promise<ExecutionListResponse[]> {
    const { associate_brand_id } = params;
    return await this.restClient.get<ExecutionListResponse[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/menu-management/sync?associate_brand_id=${associate_brand_id}` as const
    );
  }

  public async create(
    params: MenuManagementExecutionCreateParams
  ): Promise<void> {
    return await this.restClient.post<
      MenuManagementExecutionCreateParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/menu-management/sync` as const,
      params
    );
  }

  public async show(id: string): Promise<ShowExecutionResponse> {
    return await this.restClient.get<ShowExecutionResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/menu-management/sync/${id}` as const
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/menu-management/sync/${id}` as const
    );
  }
}
